<template>
    <div class="pdf-container">
        <!-- Primera página con info del acta -->
        <div class="page" style=" margin-top: 0.15mm !important;">
            <div>
                <p><b>foja N:</b> {{ 1 }}</p>
                <h1>Acta N°: {{ infraction.act.act_number.toString().padStart(6, '0') }}</h1>
            </div>
            <div class="footer">
                <img src="/img/footer.png" alt="" class="logoConstancia" />
            </div>
        </div>

        <!-- Segunda página con información general -->
        <div class="page" style=" margin-top: 0.13mm !important;height: 222.5mm !important;">
            <div>
                <p><b>foja N:</b> {{ 2 }}</p>
                <h2>Monto a pagar: {{ infraction.cost }}</h2>
            </div>
            <div class="footer">
                <img src="/img/footer.png" alt="" class="logoConstancia" />
            </div>
        </div>
        <!--:style="{ marginTop: `${index *(index > 21 ? 0.001 : 0.01 )+ index * 0.007}mm` }"-->
        <!-- nueva foja por cada cambio -->
        <div v-for="(item, index) in combinedList" :key="'state-' + index" class="page"
            :style="{ marginTop: `${((1 + index) % 2) * 0.20}mm`, height: '222.65mm' }">
            <div style="padding-top: 10%; border: 0px solid #007bff;">
                <p><b>foja N:</b> {{ index + 3 }}</p>
                <p><b>Estado:</b> {{ item.state?.state_name }}</p>
                <p v-if="item.infractor_cuil"><b>Titular CUIL:</b> {{ item.infractor_cuil }}</p>
                <p v-if="item.comment"><b>Comentario:</b> {{ item.comment }}</p>
                <p>1111</p>
                <p>1111</p>
                <p>1111</p>
                <p>1111</p>
            </div>
            <div class="links-refer" style="margin-bottom: 0%; border: 0px solid #007bff;">
                <div v-if="item.files?.length > 0">
                    <h3>Archivos adjuntos:</h3>
                    <div v-for="(file, index) in item.files" :key="index">
                        <a :href="file" target="_blank" rel="noopener noreferrer" style="font-size: small;">{{ file.url }}</a>
                    </div>
                </div>
                <div class="footer">
                    <img src="/img/footer.png" alt="" class="logoConstancia" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ControledTemp",
    props: {
        infraction: Object
    },
    data() {
        return {
            currentDate: new Date().toLocaleDateString(),
        };
    },
    computed: {
        combinedList() {
            const states = this.infraction.statesInfraction.map((item) => ({
                ...item,
                type: "state"
            }));
            const covers = this.infraction.coverChanges.map((item) => ({
                ...item,
                type: "coverChange"
            }));
            return [...states, ...covers].sort(
                (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
            );
        }
    }
};
</script>

<style>
.logoConstancia {
    object-fit: fill;
    height: 30px;
    width: 100%;
}

.footer {
    width: 100%;
    height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /*padding-left: 21px;*/
    position: relative;
    bottom: 0;
    right: 0;
    gap: 15px;
    margin-top: 25px;
}

.links-refer {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.pdf-container {
    position: relative;
    width: 100%;
    max-width: 600px;
    /* height: 841.4px;
    /* Ajusta este valor si es necesario */
    height: 222.6mm;
    margin: 0 auto;
    /* Centra el contenido 
    padding: 20px;*/
    background: #ffffff;
    font-family: "Arial", sans-serif;
    text-align: center;
}

.page {
    position: relative;
    /* margin-top: 2%;
    margin-bottom: 5%;
    padding-top: 2%;*/
    /* intentando con px 
    margin-top: 40px;
    margin-bottom: 15px;
    padding-top: 5px;
    /* padding-bottom: 5%; 
    margin-bottom: 0.56px;*/
    height: 100%;
    page-break-before: always;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* Fuerza nueva hoja en PDF 
    border-bottom: 1px solid #007bff;*/
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
</style>